import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceClientListScreen } from '@/features/clients/components/workspace/ClientListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/clients/')({
  beforeLoad: () => {
    requirePermission('client:read');
  },
  component: WorkspaceClientListScreen,
  staticData: { crumb: 'Clients' },
});
